import { BaseApi } from "./base";
import { GAME_CONFIG } from "../enums/modules/game";

const apiUrl = "/v1/service/cashpoint/";

export const AddressServiceAPI = {
  getProvinces(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_CASH_POINT_URL + apiUrl + "provinces",
      params
    );
  },

  getDistricts(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_CASH_POINT_URL + apiUrl + "districts",
      params
    );
  },

  getWards(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_CASH_POINT_URL + apiUrl + "wards",
      params
    );
  },
};
